export interface LocationData {
  Address: string;
  LogoInfo: any;
  AreaIDs: Array<any>;
  Coordinates: Array<number>;
  CreateBy: string;
  CustomerID: string;
  Customization: Array<any>;
  Description: string;
  IsActive: boolean;
  IsDeleted: boolean;
  Latitude: number;
  Location: string;
  CustomerName: any;
  Longitude: number;
  Searchable: boolean;
  Tags: Array<string>;
  TimeZone: string;
  UpdatedBy: string;
  createdAt: string;
  updatedAt: string;
  _id: string;
  Default?: boolean;
  Rule?: Rule;
  OpenNow?: boolean;
  AdvancedEmails?: AdvancedEmails;
}
interface Rule {
  OpenTimes?: OpenTimes;
}
interface OpenTimes {
  DayHours?: DayHour[];
}
interface DayHour {
  Day?: string;
  OpenTimes?: string;
  CloseTimes?: string;
  Enable?: boolean;
}

export enum Days {
  Sunday = 0,
  Monday = 1,
  Tuesday = 2,
  Wednesday = 3,
  Thursday = 4,
  Friday = 5,
  Saturday = 6,
}

export interface AdvancedEmails {
  AdvancedEmailAlias: AdvancedEmailAliasData[];
  Enabled: boolean;
}

export interface AdvancedEmailAliasData {
  CombinationType: COMBINATION_TYPE;
  Email: string;
  AliasEmail: string;
}

export enum COMBINATION_TYPE {
  default = 'default',
  color = 'color',
  color_onesided = 'color_onesided',
  color_twosided = 'color_twosided',
  bw = 'bw',
  bw_onesided = 'bw_onesided',
  bw_twosided = 'bw_twosided',
}
